import {BusinessInfo} from '@wix/auto_sdk_ecom_cart-v-2';

export class BusinessInfoModel {
  public languageCode: string;

  constructor(params: BusinessInfoModel) {
    this.languageCode = params.languageCode;
  }

  public static fromCheckoutV1(languageCode: string) {
    return new BusinessInfoModel({
      languageCode,
    });
  }

  public static fromCartV2(businessInfo: BusinessInfo): BusinessInfoModel {
    return new BusinessInfoModel({
      languageCode: businessInfo.languageCode!,
    });
  }
}
